import { Avatar, Dropdown, type DropdownItem } from '@aliza/ui';
import { useAuth } from '../hooks/auth-context';

export interface UserMenuProps {
  onProfileClick?: () => void;
}

export function UserMenu({ onProfileClick }: UserMenuProps) {
  const { user, logout } = useAuth();

  if (!user) return null;

  const items: DropdownItem[] = [
    ...(onProfileClick ? [{ label: 'Profile', value: 'profile' }] : []),
    { label: 'Logout', value: 'logout' },
  ];

  function handleSelect(value: string) {
    if (value === 'profile') onProfileClick?.();
    if (value === 'logout') logout();
  }

  return (
    <Dropdown
      items={items}
      onSelect={handleSelect}
      trigger={
        <button
          type="button"
          aria-label="User menu"
          style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
        >
          <Avatar src={user.avatarUrl} name={user.displayName || user.username} size="sm" />
          <span>{user.displayName || user.username}</span>
        </button>
      }
    />
  );
}
